import { InjectionToken } from "@angular/core";

export interface IFlag {
    code: number;
    name: string;
    type: number | null;
}

export type IFlagsDefinition = IFlag[];

export enum DiffCostIndicatorsColors {
    Unmarked,
    Desired,
    Started,
    Unwanted,
    Unclear
}

export const MIXED_FLAGS_STATUS = 255;

export const FLAGS_MENU_DEFINITION = new InjectionToken<{
    definition: IFlagsDefinition;
    current: number;
}>("FLAGS_MENU_DEFINITION");
